import React from 'react';

// CD-5529: Power BI "Demo Client Report" embedded for the BI test audience (BITestPage role;
// DomoIFrameView also opens it since CD-5566).
// `autoAuth=true` means Power BI signs the viewer in with their own Microsoft account (same tenant),
// so the report is visible only to users who have been granted access to it in Power BI itself.
const POWER_BI_DEMO_CLIENT_REPORT_URL =
  'https://app.powerbi.com/reportEmbed?reportId=9001ccc8-ab04-4660-87cc-3c6211bbb9ec&autoAuth=true&ctid=145a5b85-93aa-4868-afa0-adedc904ec7a&actionBarEnabled=true';

export default function BiTestReports() {
  return (
    <div className='contentwrapperiframe bg-white'>
      <iframe
        title='Demo Client Report'
        src={POWER_BI_DEMO_CLIENT_REPORT_URL}
        className='report-frame'
        id='biTestReports'
        name='biTestReports'
        allowFullScreen
      />
    </div>
  );
}
